import { fetchClient } from "@babackapp/private-api-client/generated/client";
import { useQuery } from "@tanstack/react-query";

export type ProductRecommendation = {
  id: string;
  shopId: string;
  pairType: "same_order" | "customer_history";
  sourceId: string;
  targetId: string;
  productIdSource: string;
  productIdTarget: string;
  coOccurrenceCount: number;
  uniqueCustomers: number;
  support: number;
  confidence: number;
  jaccard: number;
  lift: number;
  rankingScore: number;
  computedAt: number;
  targetProductTitle: string | null;
  targetImageUrl: string | null;
};

type TestParams = {
  shopId: string;
  sourceId: string;
  pairType?: "same_order" | "customer_history";
  limit?: number;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const untypedGet = fetchClient.GET as unknown as (
  url: string,
  init: { params: { query: Record<string, string | number | undefined> } },
) => Promise<{ data: ProductRecommendation[] | undefined; error: unknown }>;

export function useProductRecommendationsTest(
  params: TestParams,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ["product-recommendations-test", params],
    enabled,
    queryFn: async () => {
      const { data, error } = await untypedGet(
        "/internal/product-recommendations/test",
        {
          params: {
            query: {
              shopId: params.shopId,
              sourceId: params.sourceId,
              pairType: params.pairType,
              limit: params.limit,
            },
          },
        },
      );
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 10_000,
  });
}
